<template>
  <div id="jobIndicators">
    <h1>当前职级</h1>
    <div class="container">
      <div class="floor-1">
        <div class="lv-radar-chart">
          <h5>{{ RankName }}</h5>
          <div class="his-lv">
            <el-button @click="goZcLog" size="mini" type="primary">职称历程</el-button>
          </div>
          <DomeEchartWrap ref="lvRadar" id="lvRadar"></DomeEchartWrap>
        </div>
        <div class="right-lv">
          <h5>成长历程</h5>
          <div class="riglv__container">
            <div class="lv-now-title">
              <h2>{{ lvFloorCodeTxt }}</h2>
              <div class="start-wrap">
                <div class="start-line">
                  <div class="start" :class="[lvFloorCodeNumber>=index?'h-start':'']" v-for="(item,index) in lvIconLists"></div>
                </div>
                <div class="s-line-wrap">
                  <div class="ss-wrap">
                    <div class="s-line">
                      <div class="s-line-n" :style="{width:`${lvFloorCodeNumber*20}%`}"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="lc-wrap">
              <!-- <div @mouseenter="changeIconLight(0)" @mouseleave="changeeIconGray(0)" class="lv-item beyond">
                <div class="lc-img"></div>
              </div>
              <div @mouseenter="changeIconLight(1)" @mouseleave="changeeIconGray(1)" class="lv-item not-reached">
                <div class="lc-img"></div>
              </div>
              <div
                @mouseenter="changeIconLight(2)"
                @mouseleave="changeeIconGray(2)"
                class="lv-item"
                :class="[lvListsIcon === 2?'beyond':'']"
              >
                <div class="lc-img"></div>
              </div>
              <div
                @mouseenter="changeIconLight(3)"
                @mouseleave="changeeIconGray(3)"
                class="lv-item"
                :class="[lvListsIcon === 3?'beyond':'']"
              >
                <div class="lc-img"></div>
              </div> -->
              <div
                @mouseenter="changeIconLight(index,item)"
                @mouseleave="changeeIconGray(index)"
                class="lv-item"
                :class="[
                  // lvListsIcon === index ?'lv-h':'lv-d'
                  checkLvListsIcon(lvListsIcon,index)?'lv-h':'lv-d'
                ]"
                v-for="(item,index) in lvIconLists"
              >
                <div
                  class="lv-tag-title"
                  :style="{
                    top:item.top
                  }"
                >
                  <div class="mq-lv" v-show="lvFloorCode === item.code">当前等级</div>
                  {{ item.label }}
                </div>
                <div
                  class="lc-img"
                  :class="[
                    checkLvListsIcon(lvListsIcon,index)?`lv-h-${index+1}`:`lv-d-${index+1}`
                  ]"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lv-lists-tb">
        <el-table
          :data="tableData"
          style="width: 100%"
          v-show="true"
        >
          <el-table-column
            prop="lv"
            label="能力"
            width="180"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="lv1"
            label="lv1"
            align="center"
          >
            <template v-slot="slotProp">
              <!-- <div v-show="checkVisiText(slotProp.row.lv1abilityLevel)"> -->
              <div>
                {{ slotProp.row.lv1 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="lv2"
            label="lv2"
            align="center"
          >
            <template v-slot="slotProp">
              <!-- <div v-show="checkVisiText(slotProp.row.lv2abilityLevel)"> -->
              <div>
                {{ slotProp.row.lv2 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="lv3"
            label="lv3"
            align="center"
          >
            <template v-slot="slotProp">
              <!-- <div v-show="checkVisiText(slotProp.row.lv3abilityLevel)"> -->
              <div>
                {{ slotProp.row.lv3 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="lv4"
            label="lv4"
            align="center"
          >
            <template v-slot="slotProp">
              <!-- <div v-show="checkVisiText(slotProp.row.lv4abilityLevel)"> -->
              <div>
                {{ slotProp.row.lv4 }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="lv5"
            label="lv5"
            align="center"
          >
            <template v-slot="slotProp">
              <div v-show="checkVisiText(slotProp.row.lv5abilityLevel)">
                {{ slotProp.row.lv5 }}
              </div>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { watchEffect, watch, onMounted, reactive, ref, getCurrentInstance, inject, computed } from '@vue/composition-api'
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'

export default {
  name: 'JobIndicators',
  props: [

  ],
  setup () {
    const lvRadar = ref(null)
    const vm = getCurrentInstance()
    let userId = inject('userId')
    let option = {
      color: ['blue', 'red', '#56A3F1', '#FF917C'],
      tooltip: {
        trigger: 'axis'
      },
      radar: [
        {
          indicator: [
            // { text: '诚信正直' },
            // { text: '思考能力' },
            // { text: '创新改进' },
            // { text: '企业家精神' },
            // { text: '执行力' },
            // { text: '规划能力' },
            // { text: '目标管理' },
            // { text: '培养人才' },
            // { text: '领导力' }
          ],
          axisName: {
            color: '#428BD4'
          },
          radius: 120,
          splitArea: {
            areaStyle: {
              color: ['rgba(50,50,50,0.1)', 'rgba(155,155,155,0.5)'],
              shadowColor: 'rgba(0, 0, 0, 0.2)',
              shadowBlur: 10
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(122, 122, 122, 1)'
            }
          }
        }
      ],
      legend: {
        data: ['您当前能力', '当前职称所需能力'],
        top: '5%',
        left: '0',
        itemWidth: 15,
        itemHeight: 9
      },
      series: [
        {
          type: 'radar',
          tooltip: {
            trigger: 'item'
          },
          data: [
            {
              value: [],
              name: '您当前能力'
              // areaStyle: {
              //   color: {
              //     type: 'radial',
              //     colorStops: [{
              //       offset: 0, color: 'rgba(255, 145, 124, 0.1)' // 0% 处的颜色
              //     }, {
              //       offset: 1, color: 'rgba(255, 145, 124, 0.9)' // 100% 处的颜色
              //     }],
              //     global: false // 缺省为 false
              //   }
              // }
            },
            {
              value: [],
              name: '当前职称所需能力'
              // areaStyle: {
              //   color: {
              //     type: 'radial',
              //     colorStops: [{
              //       offset: 0, color: 'rgba(255, 145, 124, 0.1)' // 0% 处的颜色
              //     }, {
              //       offset: 1, color: 'rgba(255, 145, 124, 0.9)' // 100% 处的颜色
              //     }],
              //     global: false // 缺省为 false
              //   }
              // }
            }
          ]
        }
      ]
    }
    let RankName = ref('')// 职级名称
    let tableData = reactive([
      {
        lv: '诚信正直',
        lv1: '不撒谎、不作假',
        lv1abilityLevel: 0,
        lv2: '直言不讳，言出必行，行必果',
        lv2abilityLevel: 0,
        lv3: '公平公正、勤于反思、勇于担责',
        lv3abilityLevel: 0,
        lv4: '一身正气',
        lv4abilityLevel: 0

      },
      {
        lv: '思考能力',
        lv1: '解决问题的能力',
        lv1abilityLevel: 0,
        lv2: '追根溯源，高效解决问题的能力',
        lv2abilityLevel: 0,
        lv3: '寻找问题发生的规律，规避问题发生',
        lv3abilityLevel: 0,
        lv4: '举一反三，从问题发现商机并开枝散叶',
        lv4abilityLevel: 0

      },
      {
        lv: '创新改进',
        lv1: '思考创新并尝试',
        lv1abilityLevel: 0,
        lv2: '主动创新以提升效率',
        lv2abilityLevel: 0,
        lv3: '产品和业务创新',
        lv3abilityLevel: 0,
        lv4: '利用创新放大产品/服务价值',
        lv4abilityLevel: 0

      },
      {
        lv: '企业家精神',
        lv1: '攻坚克难',
        lv1abilityLevel: 0,
        lv2: '主动挑战',
        lv2abilityLevel: 0,
        lv3: '追求卓越',
        lv3abilityLevel: 0,
        lv4: '志在高远',
        lv4abilityLevel: 0
      },
      {
        lv: '执行力',
        lv1: '快速执行',
        lv1abilityLevel: 0,
        lv2: '高效执行',
        lv2abilityLevel: 0,
        lv3: '超预期执行',
        lv3abilityLevel: 0,
        lv4: '快速纠偏能力',
        lv4abilityLevel: 0

      },
      {
        lv: '规划能力',
        lv1: '产品规划能力',
        lv1abilityLevel: 0,
        lv2: '业务规划能力',
        lv2abilityLevel: 0,
        lv3: '年度战略规划能力',
        lv3abilityLevel: 0,
        lv4: '中长期战略规划能力',
        lv4abilityLevel: 0
      },
      {
        lv: '目标管理',
        lv1: '根据要求设定合理目标',
        lv1abilityLevel: 0,
        lv2: '超越要求制定挑战目标',
        lv2abilityLevel: 0,
        lv3: '根据战略设定组织目标',
        lv3abilityLevel: 0,
        lv4: '制定长期的可持续发展数据目标',
        lv4abilityLevel: 0
      },
      {
        lv: '培养人才',
        lv1: '乐于分享',
        lv1abilityLevel: 0,
        lv2: '经验沉淀',
        lv2abilityLevel: 0,
        lv3: '授权实践',
        lv3abilityLevel: 0,
        lv4: '带动引领',
        lv4abilityLevel: 0
      },
      {
        lv: '领导力',
        lv1: '识别人才、合理分配',
        lv1abilityLevel: 0,
        lv2: '建立机制、高效协同',
        lv2abilityLevel: 0,
        lv3: '激励团队、快乐工作',
        lv3abilityLevel: 0,
        lv4: '建立愿景、超越自我',
        lv4abilityLevel: 0
      }
    ])
    let tableVisible = ref(false)
    function goZcLog () {
      vm.setupContext.root.$router.push('/blevelHistoryLog?userId=' + userId)
    }
    /// 
    let lvListsIcon = ref(0)
    let lvListsIconCode = ref(false)
    let lvFloorCode = ref(false)// 当前角色信息等级段位----T1
    let lvFloorCodeNumber = ref(0)// 当前角色信息等级段位----1
    let lvIndexCount = ref(0)
    let changeIconLight = function (index, item) {
      lvListsIcon.value = index
      lvListsIconCode.value = item.code
      lvIndexCount.value = index + 1
    }
    let changeeIconGray = function (index) {
      lvListsIcon.value = ''
    }
    /// /
    let lvIconLists = reactive([
      {
        label: 'T2青铜',
        top: '41%',
        code: 'P1'
      },
      {
        label: 'T3白银',
        top: '35%',
        code: 'P2'
      },
      {
        label: 'T4黄金',
        top: '28%',
        code: 'P3'
      },
      {
        label: 'T5铂金',
        top: '21%',
        code: 'P4'
      },
      {
        label: 'T6钻石',
        top: '15%',
        code: 'P5'
      },
      {
        label: 'T7王者',
        top: '8%',
        code: 'T1'
      }
    ])

    let lvCodeEmuns = [
      [['L3', 'T1', 'P1', 'M1', 'S1'], 1],
      [['L4', 'T2', 'P2', 'M2', 'S2'], 2],
      [['L5', 'T3', 'P3', 'M3', 'S3'], 3],
      [['L6', 'T4', 'P4', 'M4', 'S4'], 4],
      [['L7', 'T5', 'P5', 'M5', 'S5'], 5]
    ]
    onMounted(() => {
      jobInfo()
    })
    // 个人能力信息----雷达、成长历程
    function jobInfo () {
      vm.proxy.$service.fetch({
        url: '/api/bsc/user/jobInfo',
        params: {
          userId: userId// 'CC1621'
        }
      }).then(res => {
        let { currentAbilityAndLevel, employJobInfo, systemAbilityAndLevel } = res;
        (currentAbilityAndLevel?.bscJobAbilities ?? []).forEach(v => {
          console.log(v)
          let { abilityName, abilityLevelDTO } = v
          option.radar[0].indicator.push({ text: abilityName })
          option.series[0].data[0].value.push(+abilityLevelDTO?.abilityLevel)
          let findItem = systemAbilityAndLevel.find(v1 => {
            return v1.abilityName === abilityName
          })
          option.series[0].data[1].value.push(+findItem?.abilityLevel)
        })
        lvRadar.value.setEchartOption(option)
        RankName.value = `${employJobInfo.jobName}${employJobInfo.jobCode}`
        JudgmentCode(employJobInfo.jobCode)
        // getRankInfo()
      })
    }
    let leveEmu = {
      's01': {
        label: '思考能力',
        d: tableData[1]
      },
      's02': {
        lable: '创新改进',
        d: tableData[2]
      },
      's03': {
        lable: '企业家精神',
        d: tableData[3]
      },
      's04': {
        lable: '诚信正直',
        d: tableData[0]
      },
      's05': {
        lable: '执行力',
        d: tableData[4]
      },
      's06': {
        lable: '目标管理',
        d: tableData[6]
      },
      's07': {
        label: '规划能力',
        d: tableData[5]
      },
      's08': {
        label: '培养人才',
        d: tableData[7]
      },
      's09': {
        label: '领导力',
        d: tableData[8]
      }
    }
    let sameLvLists = ref([])
    /// 能力表格数据
    function getRankInfo () {
      vm.proxy.$service.fetch({
        url: '/api/bsc/getRankInfo'
      }).then(res => {
        // res.forEach(v => {
        //   let { abilityCode, jobCode, levelDesc, abilityLevel } = v
        //   if (jobCode.charAt(0) !== lvFloorCode.value.charAt(0)) {
        //     return
        //   }
        //   let indexItem = lvCodeEmuns.find(v => {
        //     return v[0].includes(jobCode)
        //   })
        //   leveEmu[abilityCode].d[`lv${indexItem[1]}`] = levelDesc
        //   leveEmu[abilityCode].d[`lv${indexItem[1]}abilityLevel`] = abilityLevel
        // })
        res.forEach(v => {
          let { abilityCode, jobCode, levelDesc, abilityLevel } = v
          if (jobCode.charAt(0) !== lvFloorCode.value.charAt(0)) {
            return
          }
          sameLvLists.value.push(v)
        })
        getNowLvLists()
      })
    }
    watch(lvIndexCount, () => {
      getNowLvLists()
    })
    function getNowLvLists () {
      let newArr = []
      sameLvLists.value.forEach(v => {
        let { abilityCode, jobCode, levelDesc, abilityLevel } = v
        let indexItem = lvCodeEmuns.find(v => {
          return v[0].includes(jobCode)
        })
        // if (lvIndexCount.value < indexItem[1]) {
        //   return
        // }
        // if (indexItem[1] > +abilityLevel) { return }
        // if (lvIndexCount.value > +abilityLevel) { return }
        if (indexItem[1] !== lvIndexCount.value) { return }
        leveEmu[abilityCode].d[`lv${abilityLevel}`] = levelDesc
        leveEmu[abilityCode].d[`lv${abilityLevel}abilityLevel`] = abilityLevel
        newArr.push(v)
      })
    }
    // let tableLvisits = watchEffect(lvIndex, () => {
    //   newArr.forEach(v => {
    //     let { abilityCode, jobCode, levelDesc, abilityLevel } = v
    //     let indexItem = lvCodeEmuns.find(v => {
    //       return v[0].includes(jobCode)
    //     })
    //     leveEmu[abilityCode].d[`lv${indexItem[1]}`] = levelDesc
    //     leveEmu[abilityCode].d[`lv${indexItem[1]}abilityLevel`] = abilityLevel
    //   })
    // })
    // 成长历程图形
    function JudgmentCode (val) {
      lvFloorCode.value = val.slice(0, 2)
      let code = val.charAt(0)
      let index = 1
      if (code === 'L') { index = 3 }
      lvIconLists.forEach(v => {
        v.code = code + index
        v.label = v.code + v.label.slice(2)
        ++index
      })
      setLvFloorCodeTxt()
    }
    let checkVisiText = function (lv) {
      let indexItem = lvCodeEmuns.find(v => {
        return v[0].includes(lvListsIconCode.value)
      })
      if (!indexItem) return true
      return lv >= indexItem[1]
    }
    let checkLvListsIcon = function (lvIndex, index) {
      let classNameLists = []
      let classNameStr = 'lv-d'
      // className.push(lv === index ? 'lv-h' : 'lv-d')
      let levelIndex = -1
      if (lvFloorCode.value) {
        let indexItem = lvCodeEmuns.find(v => {
          return v[0].includes(lvFloorCode.value)
        })
        levelIndex = indexItem[1]
      }
      if (lvIndex === index || +levelIndex > index) {
        classNameStr = 'lv-h'
        return true
      }
      classNameLists.push(classNameStr)
      return false
      // return classNameLists.join(' ')
    }
    let lvFloorCodeTxt = ref('T1青铜')
    let lvTxlNameLists = ['青铜', '白银', '黄金', '铂金', '钻石']
    function setLvFloorCodeTxt () {
      let indexItem = lvCodeEmuns.find(v => {
        return v[0].includes(lvFloorCode.value)
      })
      lvFloorCodeNumber.value = indexItem[1] - 1
      lvIndexCount.value = lvFloorCodeNumber.value
      lvFloorCodeTxt.value = `${lvFloorCode.value}${lvTxlNameLists[indexItem[1] - 1]}等级`
    }
    return {
      lvFloorCodeNumber,
      lvFloorCodeTxt,
      lvFloorCode,
      checkLvListsIcon,
      lvRadar,
      tableData,
      goZcLog,
      tableVisible,
      lvListsIcon,
      changeIconLight,
      changeeIconGray,
      lvIconLists,
      checkVisiText,
      lvListsIconCode,
      RankName
    }
  },

  components: {
    DomeEchartWrap
  }
}
</script>

<style scoped lang="stylus">
#jobIndicators
  h1
    font-size: 46px
    font-weight: 800
    margin-bottom: 30px
  h5
    font-size: 25px
.floor-1
  height 500px
  display flex
  justify-content: space-around
  padding 10px
  .lv-radar-chart
    display flex
    flex-direction: column
    position: relative
  .lv-radar-chart,.right-lv
    width 48%
    box-shadow: 0 2px 12px 0 rgba(0 0 0 , 20%);
    padding 10px
    border-radius 10px
    overflow hidden
  .right-lv,.riglv__container
    display: flex
    flex-direction: column
    .riglv__container
      flex 1
    .lv-now-title
      h2
        font-size: 18px
        font-weight: bolder
        text-align: center
.his-lv
  text-align: right
  position: absolute
  right 10px
  top 10px
.lc-wrap
  display: flex
  height 100%
  justify-content: space-between
  .lv-item
    position: relative
    flex 1 0 13%
    cursor pointer
    transition all 2s linear
    &.lv-h
      background-image: linear-gradient(to top, rgba(255, 210, 111, 0) 0%,rgba(255, 210, 111, 1) 50%, rgba(255, 210, 111, 0) 100%);
      &:hover
        background-image: linear-gradient(to top, rgba(255, 210, 111, 0) 0%,rgba(255, 210, 111, 1) 25%,rgba(255, 210, 111, 1) 75%, rgba(255, 210, 111, 0) 100%);
    &.lv-d
      position: relative
      &:after
        content:''
        background-image: linear-gradient(to top, rgba(40, 38, 31, 0) 0%,rgba(40, 38, 31, 1) 50%, rgba(40, 38, 31, 0) 100%);
        opacity .5
        position absolute
        top 0
        bottom 0
        right 0
        left 0
  .lv-item+.lv-item
    margin-left 1%
.lv-item
  .lc-img
    background-size: contain
    width 100%
    height 100%
    background-repeat: no-repeat
    &.lv-d-1
      background-image url('~@/assets/images/dqzj/1d.png')
      background-position: 50% 80%
    &.lv-d-2
      background-image url('~@/assets/images/dqzj/2d.png')
      background-position: 50% 70%
    &.lv-d-3
      background-image url('~@/assets/images/dqzj/3d.png')
      background-position: 50% 60%
    &.lv-d-4
      background-image url('~@/assets/images/dqzj/4d.png')
      background-position: 50% 50%
    &.lv-d-5
      background-image url('~@/assets/images/dqzj/5d.png')
      background-position: 50% 40%
    &.lv-d-6
      background-image url('~@/assets/images/dqzj/6d.png')
      background-position: 50% 30%
    &.lv-h-1
      background-image url('~@/assets/images/dqzj/1h.png')
      background-position: 50% 80%
    &.lv-h-2
      background-image url('~@/assets/images/dqzj/2h.png')
      background-position: 50% 70%
    &.lv-h-3
      background-image url('~@/assets/images/dqzj/3h.png')
      background-position: 50% 60%
    &.lv-h-4
      background-image url('~@/assets/images/dqzj/4h.png')
      background-position: 50% 50%
    &.lv-h-5
      background-image url('~@/assets/images/dqzj/5h.png')
      background-position: 50% 40%
    &.lv-h-6
      background-image url('~@/assets/images/dqzj/6h.png')
      background-position: 50% 30%
  .lv-tag-title
    font-size: 24px
    font-weight: bolder
    position: absolute
    left: 0
    right: 0
    margin: auto
    text-align: center
    height 40px
.start-wrap
  position relative
.start-line
  display: flex
  justify-content: space-around
  width 100%
  height 40px
  position relative
  .start
    background url('~@/assets/images/dqzj/startd.png') center center no-repeat
    background-size: contain
    flex 1 0 13%
    position relative
    z-index: 5
    &.h-start
      background url('~@/assets/images/dqzj/starth.png') center center no-repeat
      background-size: contain
.s-line-wrap
  position: absolute
  bottom: 0
  top: 0
  left: 0
  right: 0
  margin: auto
  .s-line
    height 10px
    background-color: rgba(0, 0, 0, 0.1000)
    width 85%
    .s-line-n
      width 10%
      background-color: rgba(255, 210, 111, 1)
      height 100%
  .ss-wrap
    width 100%
    height 100%
    display flex
    align-items center
    justify-content center

.mq-lv
  font-size: 11px
  font-weight: 400
  margin-bottom 5px

#lvRadar
  flex 1
</style>
